import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkbox", "contextField", "destroyField" ]

  connect() {
    // console.log("Hello, Creative Modifier Controller here!", this.element);
  }

  toggleContext(event) {
    // console.log("toggleContext", event);
    // console.log(this.checkboxTarget);
    // console.log(this.contextFieldTarget);

    if(event.target.checked) {
      this.contextFieldTarget.classList.remove('d-none');
      this.destroyFieldTarget.value = '0';
    } else {
      this.contextFieldTarget.classList.add('d-none');
      this.destroyFieldTarget.value = '1';
    }
  }
}
